import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { AdminNotificationUnreadCountDto } from '../../../models/admin-notification/dto/admin-notification-feed.dto';

export const ADMIN_NOTIFICATION_UNREAD_COUNT_QUERY_KEY = 'admin-notification-unread-count';

export const useGetUnreadCount = (organizationId?: string) => {
  const client = useApiClient();

  return useQuery({
    queryKey: [ADMIN_NOTIFICATION_UNREAD_COUNT_QUERY_KEY, organizationId],
    queryFn: async () => {
      return client.fetchApi<AdminNotificationUnreadCountDto, {}>({
        endpoint: `notifications/admin/unread-count?organizationId=${organizationId}`,
        method: 'GET',
      });
    },
    enabled: !!organizationId,
    refetchInterval: 30_000,
    staleTime: 15_000,
  });
};
